module.exports = __webpack_public_path__ + "assets/overview-tags.01e1cf94.svg";